export default __webpack_public_path__ + "static/media/white-logo.d52af408.svg";